"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MhSelect = void 0;

var _vuePropertyDecorator = require("vue-property-decorator");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _http = require("../utils/http");

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var id = -1;
var MhSelect = (_dec = (0, _vuePropertyDecorator.Model)('change'), _dec2 = (0, _vuePropertyDecorator.Prop)(), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: 'label'
}), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: 'value'
}), _dec5 = (0, _vuePropertyDecorator.Prop)(), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec7 = (0, _vuePropertyDecorator.Prop)(), _dec8 = (0, _vuePropertyDecorator.Prop)({
  default: false
}), _dec9 = (0, _vuePropertyDecorator.Prop)(), _dec10 = (0, _vuePropertyDecorator.Prop)(), _dec11 = (0, _vuePropertyDecorator.Prop)({
  default: '/api/common/dropdown/direct/list'
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  _inherits(MhSelect, _Vue);

  var _super = _createSuper(MhSelect);

  function MhSelect() {
    var _this;

    _classCallCheck(this, MhSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_this, "value", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "options", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "optionLabel", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "optionValue", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "type", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "link", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "otherMatch", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "allowDiy", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "metaBaseSearchUrl", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "metaBaseSearchTag", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "searchUrl", _descriptor11, _assertThisInitialized(_this));

    _this.loading = false;
    _this.list = [];
    _this.debounceFetch = (0, _debounce.default)(_this.fetchData, 800);
    _this.searchValue = '';
    return _this;
  }

  _createClass(MhSelect, [{
    key: "searchData",
    value: function searchData(value) {
      this.loading = true;
      this.searchValue = value;
      this.debounceFetch(value);
    }
  }, {
    key: "fetchData",
    value: function fetchData(value) {
      var _this2 = this;

      var link = this.link,
          metaBaseSearchTag = this.metaBaseSearchTag,
          metaBaseSearchUrl = this.metaBaseSearchUrl;

      if ((link || metaBaseSearchTag && metaBaseSearchUrl) && value && value.length > 1) {
        this.loading = true; // 防止前面请求比后面慢 覆盖数据

        id++;
        var _id = id;
        var request = link ? _http.http.get(this.searchUrl, {
          params: {
            key: link.formId,
            searchField: link.searchFields,
            searchWord: value,
            showField: link.showFields && link.showFields.map(function (field) {
              return field && field.name || field;
            }),
            valueField: link.valueField,
            otherMatch: this.otherMatch
          }
        }) : _http.http.get(metaBaseSearchUrl, {
          params: {
            parameters: JSON.stringify([{
              type: 'category',
              target: ['variable', ['template-tag'], 'param'],
              value: null
            }, {
              type: 'category',
              target: ['variable', ['template-tag', metaBaseSearchTag]],
              value: value
            }])
          }
        });
        request.then(function (rep) {
          if (_id === id) {
            _this2.list = rep.data || [];
          }
        }).finally(function () {
          if (_id === id) {
            _this2.loading = false;
          }
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var _this3 = this;

      var value = this.value,
          type = this.type,
          factOptions = this.factOptions;

      if (!e) {
        this.$emit('change', null);
      } else if (type === '{"type":"searchLabelValue"}' || type === '{"type":"searchLabelValue","noneFlag":true}') {
        var obj = factOptions.find(function (item) {
          return item[_this3.optionValue] === e;
        });

        if (obj) {
          this.$emit('change', _objectSpread({}, obj));
        } else if (value) {
          if (value.value === e) {
            this.$emit('change', _objectSpread({}, value));
          }
        } else {
          this.$emit('change', e);
        }
      } else if (type === '{"type":"array","items":"searchLabelValue"}') {
        if (e && Array.isArray(e)) {
          this.$emit('change', e.map(function (item) {
            var obj;

            if (value && Array.isArray(value)) {
              obj = value.find(function (v) {
                return v.value === item;
              });
            }

            if (!obj) {
              obj = factOptions.find(function (v) {
                return v.value === item;
              });
            }

            return obj;
          }));
        }
      } else {
        this.$emit('change', e);
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this4 = this;

      var loading = this.loading,
          optionLabel = this.optionLabel,
          optionValue = this.optionValue,
          type = this.type,
          searchData = this.searchData,
          factValue = this.factValue,
          onChange = this.onChange,
          factOptions = this.factOptions;
      var otherProps = {};
      var isSearch = false;

      otherProps.filterOption = function (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      };

      if (type === '{"type":"searchLabelValue"}' || type === '{"type":"array","items":"searchLabelValue"}' || type === '{"type":"searchLabelValue","noneFlag":true}') {
        otherProps.notFoundContent = loading ? undefined : '暂无搜索结果';
        otherProps.filterOption = false;
        otherProps.showSearch = true;
        isSearch = true;
      }

      if (type === '{"type":"array","items":"searchLabelValue"}' || type === '{"type":"array","items":{"type":"labelValue","path":"children.options"}}') {
        otherProps.mode = 'multiple';
      }

      return h('a-select', {
        props: _objectSpread(_objectSpread(_objectSpread({}, this.$attrs), otherProps), {}, {
          value: factValue,
          options: undefined
        }),
        on: {
          change: onChange,
          search: isSearch ? searchData : function (v) {
            return _this4.searchValue = v;
          }
        }
      }, [loading && h('a-spin', {
        props: {
          size: 'small'
        },
        slot: 'notFoundContent'
      })].concat(_toConsumableArray(factOptions.map(function (opt) {
        return h('a-select-option', {
          key: opt[optionValue],
          props: {
            value: opt[optionValue]
          }
        }, opt[optionLabel]);
      }))));
    }
  }, {
    key: "factValue",
    get: function get() {
      var value = this.value,
          type = this.type,
          optionValue = this.optionValue;

      if (!value) {
        return value;
      }

      if (type === '{"type":"searchLabelValue"}' || type === '{"type":"array","items":"searchLabelValue"}' || type === '{"type":"searchLabelValue","noneFlag":true}') {
        if (Array.isArray(value)) {
          return value.map(function (v) {
            return v[optionValue];
          });
        }

        return value[optionValue];
      }

      return value;
    }
  }, {
    key: "factList",
    get: function get() {
      var idList = this.list.map(function (l) {
        return l.value;
      });

      if (this.type === '{"type":"array","items":"searchLabelValue"}' && this.value && Array.isArray(this.value)) {
        var extraList = this.value.filter(function (v) {
          return !idList.includes(v.value);
        });
        return [].concat(_toConsumableArray(extraList), _toConsumableArray(this.list));
      }

      if ((this.type === '{"type":"searchLabelValue"}' || this.type === '{"type":"searchLabelValue","noneFlag":true}') && this.value && !idList.includes(this.value.value)) {
        return [this.value].concat(_toConsumableArray(this.list));
      }

      return this.list;
    }
  }, {
    key: "factOptions",
    get: function get() {
      var _this5 = this;

      var options = this.options || [];

      if (this.type === '{"type":"searchLabelValue"}' || this.type === '{"type":"array","items":"searchLabelValue"}' || this.type === '{"type":"searchLabelValue","noneFlag":true}') {
        options = this.factList.slice();
      }

      if (this.allowDiy && this.searchValue && !options.find(function (opt) {
        return opt.value === _this5.searchValue;
      })) {
        options = [].concat(_toConsumableArray(options), [{
          label: this.searchValue,
          value: this.searchValue
        }]);
      }

      return options;
    }
  }], [{
    key: "install",
    value: function install(vue) {
      vue.component('mh-select', this);
    }
  }]);

  return MhSelect;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "options", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "optionLabel", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "optionValue", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "link", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "otherMatch", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "allowDiy", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "metaBaseSearchUrl", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "metaBaseSearchTag", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "searchUrl", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.MhSelect = MhSelect;